// This file is intended to drop in replace UTC timezones with local time and boolean entries with X or check icons.

import { Controller } from "@hotwired/stimulus"
import { DateTime } from 'luxon'

export default class extends Controller {
  static values = {
    timeFormat: String,
    dateFormat: String,
    timeZone: String
  }

  connect() {
    this.applyReplacements()
    this.bindDataTablesEvent()
  }

  disconnect() {
    this.unbindDataTablesEvent()
  }

  bindDataTablesEvent() {
    const table = this.element.querySelector('table')
    if (!table) return

    // Store the handler so we can remove it on disconnect
    this.drawHandler = () => this.applyReplacements()

    $(table).on('draw.dt', this.drawHandler)
  }

  unbindDataTablesEvent() {
    const table = this.element.querySelector('table')
    if (!table || !this.drawHandler) return

    $(table).off('draw.dt', this.drawHandler)
  }

  applyReplacements() {
    this.replaceDateTimes()
    this.replaceBooleans()
  }

  replaceDateTimes() {
    const dateTimeElements = document.querySelectorAll('td.datetime')
    dateTimeElements.forEach(element => {
      this.replaceDateTime(element)
    })
  }

  replaceDateTime(element) {
    const dateString = element.textContent
    const dateTime = DateTime.fromSQL(dateString)

    if (dateTime.isValid) {
      const convertedDateTime = dateTime.setZone(this.timeZoneValue).toFormat(this.dateFormatValue + ' ' + this.timeFormatValue)
      element.textContent = convertedDateTime
    }
  }

  replaceBooleans() {
    const booleanElements = document.querySelectorAll('td.boolean')

    booleanElements.forEach(element => {
      this.replaceBoolean(element)
    })
  }

  replaceBoolean(element) {
    const boolean = element.textContent
    if (boolean.length == 0 || boolean.toLowerCase() == 'no' || boolean.toLowerCase() == 'false') {
      element.innerHTML = '<i title="No" class="fa fa-times"></i><span class="sr-only">No</span>'
    } else {
      element.innerHTML = '<i title="Yes" class="fa fa-check"></i><span class="sr-only">Yes</span>'
    }
  }
}
